import axios from 'axios';


export default (body, callback, errorCallback, apiUrl, headers) => {
  axios({
    method: 'POST',
    url: apiUrl + '/rt/console/messaging/new-thread',
    data: {
      userId: body.userId,
      nct:  body.nct,
      message: body.message,
      subject: body.subject,
      instance: body.instance,
      source: "console",
      ...headers,
    }
  })
  .then(res => callback(res))
  .catch(err => errorCallback ? errorCallback(err) : null)
}
